import { style, globalStyle } from '@vanilla-extract/css'
import { vars } from '../design/theme.css'
import { gloss, sectionHead } from '../design/primitives/text.css'
import { ruledList, ruledRow, ruledLabel } from '../design/primitives/layout.css'

// The account drawer's content — identity, the daily-letter toggle, the followed species.
// Structure lives here; the controls (checkbox, select, unfollow, links) are design-system
// primitives (Checkbox / Select / Button). Migrated off the .acct-* cascade.

// Profile header — the signed-in identity, quiet and unchromed.
export const me = style({
  display: 'flex',
  alignItems: 'center',
  gap: vars.space[3],
  marginTop: vars.space[5],
})
export const avatar = style({
  width: vars.space[7],
  height: vars.space[7],
  borderRadius: vars.radius.pill,
  flex: 'none',
  objectFit: 'cover',
  background: vars.color.paper2,
})
export const avatarInitial = style([
  avatar,
  {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: vars.color.inkSoft,
    fontFamily: vars.font.serif,
    fontSize: vars.fs.lg,
  },
])
export const meId = style({ display: 'flex', flexDirection: 'column', minWidth: 0 })
export const meName = style({ fontFamily: vars.font.serif, fontSize: vars.fs.md, color: vars.color.ink })
export const meEmail = style({ fontFamily: vars.font.mono, fontSize: vars.ms.sm, color: vars.color.inkSoft })
export const meAdmin = style({ marginLeft: 'auto' })

export const sec = style({ marginTop: vars.space[7] })
// The shared section head over the soft rule — the same heading the admin console's panes and
// the species sheet's record wear. It was a size larger and a shade lighter than either.
export const h2 = style([
  sectionHead,
  {
    borderBottom: `1px solid ${vars.color.rule}`,
    paddingBottom: vars.space[2],
    marginBottom: vars.space[3],
  },
])
export const note = style({
  color: vars.color.inkSoft,
  fontFamily: vars.font.serif,
  fontSize: vars.fs.sm,
  margin: `0 0 ${vars.space[3]}`,
})

// Ruled rows — a label on the left, the control on the right. Shared with the admin console,
// which carried a byte-identical copy of these three rules.
export const rules = ruledList
export const rule = ruledRow
export const ruleLabel = ruledLabel

// The followed-species list.
export const list = ruledList
export const item = ruledRow
export const name = ruledLabel
export const ga = gloss
export const add = style({ display: 'flex', gap: vars.space[2], marginTop: vars.space[4] })

export const foot = style({
  marginTop: vars.space[8],
  paddingTop: vars.space[5],
  borderTop: `1px solid ${vars.color.rule}`,
})
globalStyle(`${foot} form`, { margin: 0 })
